import { Injectable } from '@angular/core';
import { ElementInhoudInterface } from '@app/core/interfaces';
import { ElementsService } from '@inshared/shared/data-access-elements';
import { NewModal as ModalService, PolicyProductIdEnum } from 'outshared-lib';
import { Observable } from 'rxjs';
import { PremiumDeterminingFactorElementNameEnum } from './enums/premium-determining-factor-element-name.enum';
@Injectable({
    providedIn: 'root',
})
export class InsurancePremiumDeterminingFactorService {

    constructor(
        private elementsService: ElementsService,
        private modalService: ModalService,
    ) { }

    public getOptions$(elementName: string): Observable<ElementInhoudInterface[]> {
        const factorElementName = PremiumDeterminingFactorElementNameEnum[elementName];
        const element = factorElementName ? factorElementName : elementName;

        return this.elementsService.getElementContent$(element);
    }

    public async openBonusMalusStepModal(productId: PolicyProductIdEnum): Promise<void> {
        const { InsurancePremiumDeterminingFactorBonusMalusModal } = await import('./insurance-premium-determining-factor-bonus-malus-modal/insurance-premium-determining-factor-bonus-malus.modal');
        const modalRef = this.modalService.open(InsurancePremiumDeterminingFactorBonusMalusModal);
        modalRef.componentInstance.productId = productId;
    }

    public async openDamageFreeYearsModal(productId: PolicyProductIdEnum): Promise<void> {
        switch (productId) {
            case PolicyProductIdEnum.Car:
                const { InsurancePremiumDeterminingFactorCarModal } = await import('./insurance-premium-determining-factor-car-modal/insurance-premium-determining-factor-car.modal');
                this.modalService.open(InsurancePremiumDeterminingFactorCarModal);
                break;
            case PolicyProductIdEnum.Moped:
                const { InsurancePremiumDeterminingFactorMopedModal } = await import('./insurance-premium-determining-factor-moped-modal/insurance-premium-determining-factor-moped.modal');
                this.modalService.open(InsurancePremiumDeterminingFactorMopedModal);
                break;
            case PolicyProductIdEnum.Motorcycle:
                const { InsurancePremiumDeterminingFactorMotorcycleModal } = await import('./insurance-premium-determining-factor-motorcycle-modal/insurance-premium-determining-factor-motorcycle.modal');
                this.modalService.open(InsurancePremiumDeterminingFactorMotorcycleModal);
                break;
        }
    }
}
